/*
 * Resumen ejecutivo del dashboard (para gerencia): frases cortas con lo más importante del periodo
 * (utils/dashboard.js executiveSummary) y contra qué periodo se compara. `inProgress` avisa que el
 * periodo sigue en curso (los datos llegan hasta hoy).
 */
import React from "react";
import {comparisonNote, executiveSummary} from "../../utils/dashboard";

const SummaryPanel = ({datos, inProgress}) => {
    const lines = executiveSummary(datos);
    const note = comparisonNote(datos.periodo_anterior, inProgress);
    return (
        <div className="mc-panel mc-summary">
            <h3 className="mc-panel__title">Resumen del periodo{inProgress ? ' (en curso)' : ''}</h3>
            {lines.length === 0
                ? <p className="mc-inline-empty">Todavía no hay datos suficientes para un resumen.</p>
                : <ul className="mc-summary__list">{lines.map((line) => <li key={line}>{line}</li>)}</ul>}
            {note ? <p className="mc-panel__hint">{note}</p> : null}
        </div>
    );
};

export default SummaryPanel;
